import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { AddressFilterCityRow } from '../components/filter/address-filter/address-filter-city-row.interface';

@Pipe({
    name: 'filterAddressCity',
})
@Injectable()
export class FilterAddressCityPipe implements PipeTransform {
    transform(values: AddressFilterCityRow[], input: string | number): AddressFilterCityRow[] {
        if (!values?.length) {
            return [];
        }

        if (!input) {
            return values;
        }

        const search = String(input).trim().toLowerCase();
        if (!search) {
            return values;
        }

        return values.filter((city) => city.label.toLowerCase().indexOf(search) > -1 || city.value.toLowerCase().indexOf(search) > -1);
    }
}
